import React from 'react'

import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'
import { AccordionDetails, Typography } from '@mui/material'
import { SearchOutlined, ThumbDown, ThumbUp } from '@mui/icons-material'
import StopIcon from '@mui/icons-material/Stop'
import { Expansible } from 'components/Expansible'
import _ from 'lodash'
import HelpDialogButton from 'components/ResumeTable/HelpDialogButton'
import { reviewStyles } from './styles'
import { AreaContainer, TitleContainer } from '../styles'
import BuildListItem from '../BuildListItem'

export default function ReviewsCompleteList({ bgcReviews, hideHelpButton, onDataChange }) {
  const classes = makeStyles(() => reviewStyles)()
  const splitAreas = (issues) => {
    const rh = []
    const compliance = []

    issues.forEach((issue) => {
      if (issue.user_role === 'Recursos Humanos') rh.push(issue)
      if (issue.user_role === 'Compliance') compliance.push(issue)
    })

    return { rhReviews: rh, complianceReviews: compliance }
  }

  const renderTitleExpansible = (reviewsList, area) => {
    const countReviews = (decisionFilter) =>
      reviewsList.filter((r) => r.decision === decisionFilter).length

    return (
      <TitleContainer>
        <p
          style={{
            color:
              area === 'Recursos Humanos'
                ? Colors.rhBlue
                : Colors.compliancePurple,
          }}
        >
          Análise(s) requerida(s){' '}
          {area === 'Recursos Humanos'
            ? 'dos Recursos Humanos'
            : 'do Compliance'}
        </p>
        <div style={{ display: 'flex', gap: '1rem' }}>
          <div
            className={classes.iconLabel}
            style={{ backgroundColor: Colors.loginLigthenPrimaryColor }}
          >
            <SearchOutlined fontSize="small" />
            <span className={classes.iconText}>
              Pendentes: {countReviews('WAITING_DECISION')}
            </span>
          </div>

          <div
            className={classes.iconLabel}
            style={{ backgroundColor: Colors.yellow }}
          >
            <StopIcon fontSize="small" />
            <span className={classes.iconText}>
              Suspensos: {countReviews('SUSPENDED')}
            </span>
          </div>

          <div
            className={classes.iconLabel}
            style={{ backgroundColor: Colors.reprovedRed }}
          >
            <ThumbDown fontSize="small" />
            <span className={classes.iconText}>
              Reprovados: {countReviews('REPROVED')}
            </span>
          </div>

          <div
            className={classes.iconLabel}
            style={{ backgroundColor: Colors.approvedGreen, marginRight: 2 }}
          >
            <ThumbUp fontSize="small" />
            <span className={classes.iconText}>
              Aprovados: {countReviews('APPROVED')}
            </span>
          </div>
        </div>
      </TitleContainer>
    )
  }

  const renderReviewsSplittedByArea = (reviews) => {
    const { rhReviews, complianceReviews } = splitAreas(reviews)

    const showNoReviews = () => (
      <Typography >
        Não foi derivada nenhuma revisão para esta área.
      </Typography>
    )
    const showAreaAccordion = (area) => {
      const reviewsList =
        area === 'Recursos Humanos' ? rhReviews : complianceReviews

      const reviewsEmpty = _.isEmpty(reviewsList)
      return (
        <AreaContainer>
          <Expansible title={renderTitleExpansible(reviewsList, area)}>
            <AccordionDetails>
              {reviewsEmpty ? showNoReviews() : reviewsList.map((issue) => {
                return (
                  <BuildListItem
                    key={issue.uuid}
                    issue={issue}
                    onDataChange={onDataChange}
                  />
                )
              })}
            </AccordionDetails>
          </Expansible>
        </AreaContainer>
      )
    }
    return (
      <React.Fragment>
        {showAreaAccordion('Recursos Humanos')}
        {showAreaAccordion('Compliance')}
      </React.Fragment>
    )
  }

  const renderNoReviewsMessage = () => (
    <div style={{ textAlign: 'center', marginTop: '10rem' }}>
      <Typography>
        <strong>Não foi derivada nenhuma revisão para esta aplicação.</strong>
      </Typography>
    </div>
  )

  const hasBgcReviews = !_.isEmpty(bgcReviews)

  return (
    <div className={classes.gappedItem}>
      {!hasBgcReviews ? (
        renderNoReviewsMessage()
      ) : (
        <React.Fragment>
          { !hideHelpButton && <div>
            <HelpDialogButton />
          </div>}

          {hasBgcReviews && (
            <Expansible title={`Todas as revisões (${bgcReviews?.length || 0})`} open={!hasBgcReviews}>
              {renderReviewsSplittedByArea(bgcReviews, 'BGC')}
            </Expansible>
          )}
        </React.Fragment>
      )}


    </div>
  )
}
